// extracted by mini-css-extract-plugin
export default {"label":"CheckboxV2_label__PAhWE","elipsis":"CheckboxV2_elipsis__VmlkS"};